module.exports = __webpack_public_path__ + "static/media/arrow-left.77cffa33.svg";